import React from 'react';
import '../stylesheets/screen.css'

const Pantalla = ({input})=>{
    return (
    <div className='input'>
        {input}
    </div>)
};

export default Pantalla;